import React, { useState, useCallback, useEffect } from "react";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { getCustomerDomain, getCustomerByBusinessId, getContract } from "net/contracts";
import { useDispatch, useSelector } from "react-redux";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { Container, Row, Col } from "react-grid-system";
import "views/contractView/styles/newElementFormStyles.css";
import { InputAttach, Button, Select } from "@ds/ds-snam/react";
import { useLoaderData, useParams, useNavigate } from "react-router-dom";
import { DATE_FORMAT, RoutePath, ClientType, FormMode, DocumentType, CalendarMode, DsLayout, ResponseStatus, ResponseCode } from "shared/constants";
import { StepperType } from "views/contractView/components/newElementFormStepper";
import Stepper from "views/contractView/components/newElementFormStepper";
import { IContract, IDocument, ICustomer, IContractLimit } from "dataModels/contract";
import { FileStatusEnum, IFileUpload } from "dataModels/fileInput";
import ContractFormDataInput from "views/contractView/components/contractFormDataInput";
import ContractFormReview from "views/contractView/components/contractFormReview";
import moment from "moment";
import DSFileInput from "components/DSFileInput";
import { postContract, putContractInfo } from "net/contracts";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { showNotification, hideNotification } from "state/reducer/notificationSlice";
import SystemError from "components/SystemError";
import { DSInput, DSFile } from "@ds/ds-snam/dist/index";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { RootState } from "state/appStore";



const ContractForm: React.FC = (): JSX.Element => {
    //Customer id - When access to retrieve and edit customer existing information, otherwise undefined
    const { id } = useParams();
    //Loaded contract data when in edit mode
    const contractData: IContract | undefined = useLoaderData() as IContract;

    //eslint-disable-next-line
    const [formMode, setFormMode] = useState<number>(id ? FormMode.EDIT : FormMode.NEW);

    const getDefaultFormData = (): IContract => {
        const defaultFormData: IContract = {
            id: "",
            customerId: "",
            customerName: "",
            customerVat: "",
            code: "",
            startDate: Math.floor(Date.now() / 1000),
            endDate: Math.floor(Date.now() / 1000),
            slot: 0,
            topPercentage: 0,
            rateLoading: 0,
            rateCoolDown: 0,
            rateGasUp: 0,
            rateSemiTrailerApproval: 0,
            rateDriverApproval: 0,
            rateSemiTrailerAndDriverApproval: 0,
            rateIsoContainerApproval: 0,
            rateIsoContainerAndDriverApproval: 0,
            rateTruckTractorApproval: 0,
            rateContainerPlatformApproval: 0,
            rateLoadingLastMinute:0,
            rateLoadingLastMinuteMWh:0,
            rateLoadingMWh: 0,
            rateLoadingBioMWh: 0,
            rateCoolDownMWh: 0,
            rateGasUpMWh: 0,
            rateSemiTrailerApprovalMWh: 0,
            rateDriverApprovalMWh: 0,
            rateSemiTrailerAndDriverApprovalMWh: 0,
            rateIsoContainerApprovalMWh: 0,
            rateIsoContainerAndDriverApprovalMWh: 0,
            fineFailureTake: 0,
            //rateLoadingBio: 0,
            documents: [],
            limits: [],
            chartData: [],
            rateLoadingAvailablePlant:true,
            rateLoadingBioAvailablePlant:true,
            rateCoolDownAvailablePlant:true,
            rateGasUpAvailablePlant:true,
            rateSemiTrailerApprovalAvailablePlant:true,
            rateDriverApprovalAvailablePlant:true,
            rateSemiTrailerAndDriverApprovalAvailablePlant:true,
            rateIsoContainerApprovalAvailablePlant:true,
            rateIsoContainerAndDriverApprovalAvailablePlant:true,
            rateTruckTractorApprovalAvailablePlant:true,
            rateContainerPlatformApprovalAvailablePlant:true,
            rateLoadingAvailable:true,
            rateLoadingBioAvailable:true,
            rateCoolDownAvailable:true,
            rateGasUpAvailable:true,
            rateSemiTrailerApprovalAvailable:true,
            rateDriverApprovalAvailable:true,
            rateSemiTrailerAndDriverApprovalAvailable:true,
            rateIsoContainerApprovalAvailable:true,
            rateIsoContainerAndDriverApprovalAvailable:true,
            rateTruckTractorApprovalAvailable:true,
            rateContainerPlatformApprovalAvailable:true,
        }
        return defaultFormData;
    }

    const { t } = useTranslation(['contract', 'app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const [customerList, setCustomerList] = useState<ISelectLabel[]>([]);
    const [selectedBusiness, setSelectedBusiness] = useState<ISelectLabel | undefined>();
    const [formStep, setFormStep] = useState<number>(formMode === FormMode.NEW ? 0 : 1);

    const [customerData, setCustomerData] = useState<ICustomer | undefined>();
    const [formError, setFormError] = useState<boolean>(false);
    const [minEndDate, setMinEndDate] = useState<Date | undefined>();

    const [formData, setFormData] = useState<IContract>(formMode === FormMode.NEW ? getDefaultFormData() : contractData);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(()=>{
        if(formData && (formMode === FormMode.NEW)){
            dispatch(requestPending());
            getContract("-1")
                .then((response) => {
                    const contractResponse = response.data;
                    contractResponse.startDate=Math.floor(Date.now() / 1000);
                    contractResponse.endDate=Math.floor(Date.now() / 1000);
                    /*let mock:IContract = {
                        id: "",
                        customerId: "",
                        customerName: "",
                        customerVat: "",
                        code: "",
                        startDate: Math.floor(Date.now() / 1000),
                        endDate: Math.floor(Date.now() / 1000),
                        slot: 0,
                        topPercentage: 0,
                        rateLoading: 0,
                        rateCoolDown: 0,
                        rateGasUp: 0,
                        rateSemiTrailerApproval: 0,
                        rateDriverApproval: 0,
                        rateSemiTrailerAndDriverApproval: 0,
                        rateIsoContainerApproval: 0,
                        rateIsoContainerAndDriverApproval: 0,
                        rateTruckTractorApproval: 0,
                        rateContainerPlatformApproval: 0,
                        rateLoadingMWh: 0,
                        rateLoadingBioMWh: 0,
                        rateCoolDownMWh: 0,
                        rateGasUpMWh: 0,
                        rateSemiTrailerApprovalMWh: 0,
                        rateDriverApprovalMWh: 0,
                        rateSemiTrailerAndDriverApprovalMWh: 0,
                        rateIsoContainerApprovalMWh: 0,
                        rateIsoContainerAndDriverApprovalMWh: 0,
                        fineFailureTake: 0,
                        rateLoadingBio: 0,
                        documents: [],
                        limits: [],
                        chartData: [],
                        rateLoadingAvailablePlant:true,
                        rateLoadingBioAvailablePlant:true,
                        rateCoolDownAvailablePlant:true,
                        rateGasUpAvailablePlant:true,
                        rateSemiTrailerApprovalAvailablePlant:true,
                        rateDriverApprovalAvailablePlant:true,
                        rateSemiTrailerAndDriverApprovalAvailablePlant:true,
                        rateIsoContainerApprovalAvailablePlant:true,
                        rateIsoContainerAndDriverApprovalAvailablePlant:true,
                        rateTruckTractorApprovalAvailablePlant:true,
                        rateContainerPlatformApprovalAvailablePlant:true,
                        rateLoadingAvailable:true,
                        rateLoadingBioAvailable:true,
                        rateCoolDownAvailable:true,
                        rateGasUpAvailable:true,
                        rateSemiTrailerApprovalAvailable:true,
                        rateDriverApprovalAvailable:true,
                        rateSemiTrailerAndDriverApprovalAvailable:true,
                        rateIsoContainerApprovalAvailable:true,
                        rateIsoContainerAndDriverApprovalAvailable:true,
                        rateTruckTractorApprovalAvailable:true,
                        rateContainerPlatformApprovalAvailable:true,
                        rateLoadingLastMinute: 0,
                        rateLoadingLastMinuteMWh:0,
                    }
                    setFormData(mock)  */  
                    
                    setFormData(contractResponse)
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                });
        }
    },[])

    const loadCustomers = useCallback(() => {
        dispatch(requestPending());
        getCustomerDomain('anag',"true")
            .then((response: ISelectLabel[]) => {
                //console.log(response)
                setCustomerList(response)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })
    }, [dispatch]);

    const loadCustomerData = useCallback(() => {
        dispatch(requestPending());
        getCustomerByBusinessId(selectedBusiness!.value!)
            .then((response) => {
                //console.log(response)
                setCustomerData(response.data)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })

    }, [selectedBusiness, dispatch]);

    useEffect(() => {
        //Load business data
        if (selectedBusiness) {
            loadCustomerData()
        }
    }, [selectedBusiness, loadCustomerData]);

    useEffect(() => {
        //When a customer is selected, set appropriate fields on formData with these customer information
        //This doesn't need to run on edit mode, as I already have these info (and I do not load customer data)
        if (formMode === FormMode.NEW && customerData) {
            let currentFormData: IContract = { ...formData };
            currentFormData.customerId = customerData?.id!;
            currentFormData.customerName = customerData?.businessName!;
            let customerVat: string = "";
            let customerType: string = customerData?.clientType!.toString()!;
            if (customerType === ClientType.IT) {
                customerVat = customerData!.vat!;
            } else if (customerType === ClientType.UE) {
                customerVat = customerData!.vatCee!;
            } else if (customerType === ClientType.EXTRA_UE) {
                customerVat = customerData!.vatExtrCee!;
            }
            currentFormData.customerVat = customerVat;
            setFormData(currentFormData);
        }
        //eslint-disable-next-line
    }, [customerData]);

    const getMinEndDate = (): Date => {
        return moment.unix(formData.startDate).toDate();
    }

    useEffect(() => {
        setMinEndDate(getMinEndDate());
        if (formMode === FormMode.NEW) {
            //Selector for customers available only in new form mode
            loadCustomers();
        }
        //eslint-disable-next-line
    }, [loadCustomers, dispatch]);

    //Destroy cleaner
    useEffect(() => {
        return () => {
            dispatch(requestPristine());
        }
    }, [dispatch]);

    const prevStep = () => {
        const nextStep = formStep - 1;
        setFormStep(nextStep);
    }
    const nextStep = () => {
        const nextStep = formStep + 1;
        setFormStep(nextStep);
    }

    const onTextInputChange = (inputEvent: Event) => {
        const fieldName = (inputEvent as CustomEvent).detail.input.name;
        let currentData: IContract = formData;
        (currentData[fieldName as keyof IContract] as string) = (inputEvent as CustomEvent).detail.input.value;
        setFormData(currentData);
    }

    const onDateInputChange = (inputEvent: Event, fieldName: string) => {
        const date: string = (inputEvent as CustomEvent).detail.dateSelection;
        let currentData: IContract = formData;
        //console.log(date, moment(date, DATE_FORMAT).unix());
        (currentData[fieldName as keyof IContract] as number) = moment(date, DATE_FORMAT).unix();

        //set end date accordingly
        //console.log(fieldName, moment.unix(formData.startDate).add(1, 'days').unix())
        if (fieldName === "startDate") {
            const currentData: IContract = { ...formData };
            currentData.endDate = moment.unix(formData.startDate).add(1, 'days').unix();
            setFormData(currentData);
            setMinEndDate(getMinEndDate());
        }
    }

    const onSelectionTimingChange = (event: Event, value: CalendarMode) => {
        //console.log(value);
        //console.log((event as CustomEvent).detail.checkbox.checked);
        const isChecked = (event as CustomEvent).detail.checkbox.checked;
        const currentLimits: IContractLimit[] = [...formData.limits];
        if (isChecked) {
            const newLimit: IContractLimit = {
                type: value,
                slot: 0,
                delta: 0
            }
            currentLimits.push(newLimit);
        } else {
            _.remove(currentLimits, (contractLimit: IContractLimit) => {
                return contractLimit.type === value;
            });
        }
        setFormData({ ...formData, limits: currentLimits });
    }

    const onContractLimitChange = (inputEvent: Event, limitType: CalendarMode) => {
        const currentLimits: IContractLimit[] = [...formData.limits];
        const fieldName = (inputEvent as CustomEvent).detail.input.name;
        const value:CalendarMode = Number((inputEvent as CustomEvent).detail.input.value);
        const foundLimit:IContractLimit|undefined = _.find(currentLimits, function (limit: IContractLimit) {
            return limit.type === limitType;
        });
        //console.log(fieldName, value, limitType, foundLimit);
        if(foundLimit){
            foundLimit[fieldName] = value;
            setFormData({...formData, limits:currentLimits});
        }
    }

    const onSwitchInputChange = (label: string, switchLabel: string) => {
        setFormData(prevState => ({
            ...prevState,
            [label]: switchLabel === "right"
        }));
    };

    const saveFormData = useCallback(() => {
        const translationField: string = formMode === FormMode.NEW ? "new" : "edit";
        const request = formMode === FormMode.EDIT ? putContractInfo : postContract;
        let popUpAction: INotificationAction;
        dispatch(requestPending());
        request(formData)
            .then((response) => {
                const popUpTitle:string = response.data.status===ResponseStatus.ERROR ? 'Error':(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT? "Warning": t(`contract.contractForm.successToast.${translationField}.title`) );
                const popUpDescription:string = response.data.status===ResponseStatus.ERROR||response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?response.data.message:t(`contract.contractForm.successToast.${translationField}.subTitle`);
                const popUpStatus:NotificationsStatusType = response.data.status===ResponseStatus.ERROR?"error":(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");
            
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription, //"Il contratto è stato inserito correttamente in piattaforma.",
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                if(formMode===FormMode.NEW){
                    navigate(RoutePath.CONTRACTS_CONTRACT_INFO);
                }else{ //edit
                    navigate(RoutePath.CONTRACTS_CONTRACT_INFO+ "/" + id); 
                }
                
            })
            .catch((error) => {
                console.log(error);
                /*popUpAction = {
                    show:true,
                    title: "Non è possibile completare l’azione",
                    description: "Si è verificato un errore durante l’inserimento del contratto. Riprova a caricare il file o contatta il nostro team di supporto.",
                    status: "error",
                    onClose: (event:Event)=>{
                        dispatch(hideNotification());
                    }
                }*/
                setFormError(true);//error step
            })
            .finally(() => {
                dispatch(requestPristine());
            })
        //eslint-disable-next-line
    }, [formData, dispatch, navigate, t]);



    const validateStep = (): number => {
        let errors: number = 0;

        if (formStep === 1) {
            const excludeList: string[] = [
                //"code",
                "topPercentage",
                //"rateLoadingBio",
                "rateCoolDown",
                "rateGasUp",
                "rateSemiTrailerApproval",
                "rateDriverApproval",
                "rateSemiTrailerAndDriverApproval",
                "rateIsoContainerApproval",
                "rateTruckTractorApproval",
                "rateContainerPlatformApproval",
                "rateIsoContainerAndDriverApproval",
                "fineFailureTake",
                "rateLoadingBioMWh",
                "rateCoolDownMWh",
                "rateGasUpMWh",
                "rateSemiTrailerApprovalMWh",
                "rateDriverApprovalMWh",
                "rateSemiTrailerAndDriverApprovalMWh",
                "rateIsoContainerApprovalMWh",
                "rateTruckTractorApprovalMWh",
                "rateContainerPlatformApprovalMWh",
                "rateIsoContainerAndDriverApprovalMWh",
            ]
            const mandatoryFields: string[] = _.filter(Object.keys(formData), (fieldName: string) => {
                return excludeList.indexOf(fieldName) === -1;
            });

            mandatoryFields.forEach((key: string) => {
                const elem: DSInput | null = document.querySelector("[input-id='" + key + "']");
                if (elem) {
                    const content = formData[key as keyof IContract]!;
                    const koCheck: boolean = content === "" || (Number(content) <= 0 && key!=="rateLoading");
                    elem.inputStatus = koCheck ? 'error' : 'default';
                    if (koCheck)
                        errors++;
                }
            });
        } else if (formStep === 2) {
            //File
            /*Object.keys(formData).forEach((key: string) => {
               const elem: DSFile| null = document.querySelector("[input-id='" + key + "']");

               if (elem) {
                   const koCheck: boolean = formData[key as keyof IContract] === null
                   elem.inputStatus = koCheck ? 'error' : 'default';
                   if (koCheck)
                       errors++;
               }
           });*/
            const elem: DSFile | null = document.querySelector("[input-id='doc']");
            const koCheck: boolean = formData.documents.length === 0;
            if (koCheck)
                errors++;
            if (elem)
                elem.inputStatus = koCheck ? 'error' : 'default';
        }

        return errors;

    }

    const headers: string[] = (() => {
        const mode: string = formMode === FormMode.NEW ? "new" : "edit";
        return t("contract.contractForm.pageHeaders." + mode, { returnObjects: true }) as string[];
    })();

    const getBase64 = (file:File) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return reader.result;
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
     }


    return (

        <>
            <p className="pageHeader">
                {headers[formStep]}
            </p>
            {formStep > 0 && formMode === FormMode.NEW && !formError && <Row>
                            <Col>
                                <Stepper
                                    stepperType={StepperType.NEW_CONTRACT}
                                    currentStep={formStep}
                                    finalStep={3} />
                            </Col>
                        </Row>}
                        {/** Customer selector - insert mode only */}
                        {formStep === 0 && <Row>
                            <Col xs={4}>
                                <div className="textInputWrapper">
                                    <Select
                                        id="customerSelector"
                                        selectId="customerSelector"
                                        menuPlaceholder=""
                                        hasIcon={false}
                                        menuOptions={customerList}
                                        menuLabel={t('contract.contractForm.sections.selector.title')}//"Scegli il cliente del contratto di riferimento"
                                        menuId="select-id"
                                        isDisabled={false}
                                        selectStatus="default"
                                        onOptionSelection={(event: Event) => {
                                            //console.log((event as CustomEvent).detail.option)
                                            const customer: ISelectLabel = (event as CustomEvent).detail.option;
                                            dsSelectHandler(customerList, customer);
                                            setSelectedBusiness(customer);
                                        }}

                                    ></Select>
                                </div>
                                <Button
                                    buttonType="button"
                                    buttonUIVariant="secondary"
                                    buttonSize="medium"
                                    buttonLabel={t('general.buttons.addElement', { ns: 'app', what: t('customer.customerList.addButton') })}//"Inserisci anagrafica cliente"//"Inserisci cliente"
                                    buttonIcon=""
                                    //isDisabled={!selectedContractId}
                                    isDisabled={false}
                                    buttonAriaLabel="insert customer button"
                                    onClickEvent={(event: Event) => {
                                        navigate(RoutePath.CONTRACTS_NEW_CUSTOMER);
                                    }}
                                ></Button>
                            </Col>
                        </Row>}
            {formStep !== 3 && formStep !== 0 &&
            <div className="listTableContainerGrey">
                
                {formError ?
                    <SystemError link={RoutePath.CONTRACTS_CONTRACT_INFO} />
                    : <>

                        {/*<Row>
                            <Col>
                                <p className="pageTitle">
                                    {formStep < 3 ?
                                        (formMode === FormMode.NEW ? t('contract.contractForm.title.0') : t('contract.contractForm.title.2'))
                                        : t('contract.contractForm.title.1')}
                                </p>
                            </Col>
                        </Row>*/}

                        {/** Stepper - insert mode only */}
                        

                        

                        {formStep === 1 && <>
                            <Row>
                                <Col>
                                    <p className="formSubTitle">
                                        {/*Inserisci le informazioni contrattuali*/}
                                        {t('contract.contractForm.sections.dataInput.title')}
                                    </p>
                                </Col>
                            </Row>

                            <ContractFormDataInput
                                formData={formData}
                                onSwitchInputChange={onSwitchInputChange}
                                onTextInputChange={onTextInputChange}
                                onDateInputChange={onDateInputChange}
                                onCheckboxChange={onSelectionTimingChange}
                                onContractLimitChange={onContractLimitChange}
                                minEndDate={minEndDate}
                            />
                        </>}

                        {formStep === 2 && <>
                            <Row>
                                <Col>
                                    <p className="formSubTitle">
                                        {t('contract.contractForm.sections.fileInput.title')}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="fileInputWrapper">
                                        <DSFileInput
                                            title={t('contract.contractForm.sections.fileInput.componentTitle') + " *"}//"Documentazione contrattuale"
                                            //inputLabel={formData.documents.length ? "Caricamento file completato. Trascina o carica un'altro file per sostituirlo" : "Trascina il file per caricarlo"}
                                            inputLabel={formData.documents.length ? t('dsComponents.fileInput.uploadedStatus.title', { ns: 'app' }) : t('dsComponents.fileInput.defaultStatus.title', { ns: 'app' })}
                                            buttonText={t('dsComponents.fileInput.defaultStatus.subTitle', { ns: 'app' })}
                                            id="doc"
                                            accept="application/pdf, image/jpg, image/jpeg"
                                            maxSize={10000000}
                                            defaultStatus={formData.documents.length ? FileStatusEnum.UPLOADED : FileStatusEnum.DEFAULT}
                                            onFileUpload={(fileUpload: IFileUpload, id: string) => {
                                                //console.log("on file upload", fileUpload.content);
                                                let base64String = btoa(fileUpload.content);
                                                let currentFormData = { ...formData };
                                                const documentObj: IDocument = {
                                                    type: DocumentType.CONTRACT, //"contract",
                                                    name: fileUpload.name,
                                                    size: fileUpload.size,
                                                    content: base64String,
                                                    expire: currentFormData.endDate,
                                                    //status:null
                                                }
                                                currentFormData.documents[0] = documentObj;
                                                setFormData(currentFormData);
                                                //console.log(formData)
                                            }}
                                        />
                                    </div>
                                    
                                </Col>
                            </Row>
                            {formData.documents.length ?
                                <div className="uploadedFileWrapper">
                                    <InputAttach
                                        attachName={formData.documents[0].name}
                                        firstButtonDisabled={false}
                                        secondButtonDisabled={false}
                                        inputLabel={t('contract.contractForm.sections.fileInput.attachTitle')}//"File caricato"
                                    />
                                </div> : <></>}
                        </>
                        }

                        
                    </>}

            </div>
            }
            {formStep === 3 &&
                            <ContractFormReview
                                formMode={formMode}
                                formData={formData}
                                customer={customerData!}
                            />}
            {/** Buttons */}
            {!formError && <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.8rem" }}>
                {formStep > 0 && <Button
                    style={{ marginRight: "0.8rem" }}
                    id="backButton"
                    buttonType="button"
                    buttonUIVariant="secondary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.back', { ns: 'app' })/*formMode === FormMode.NEW ? t('general.buttons.back', { ns: 'app' }) : t('general.buttons.cancel', { ns: 'app' })*/}//"Indietro"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={() => {
                        formMode === FormMode.NEW ? prevStep() : (formStep === 3 ? setFormStep(1) : navigate(RoutePath.CONTRACTS_CONTRACT_INFO + "/" + id));
                    }}
                />}
                {formStep < 3 /*&& ((formMode === FormMode.NEW && selectedBusiness) || formMode === FormMode.EDIT)*/ && <Button
                    id="nextButton"
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.next', { ns: 'app' })}//"Continua"
                    buttonIcon=""
                    isDisabled={!((formMode === FormMode.NEW && selectedBusiness!==undefined) || formMode === FormMode.EDIT)}
                    onClickEvent={() => {
                        let errors: number = validateStep();
                        if (errors === 0) {
                            formMode === FormMode.NEW ? nextStep() : setFormStep(formStep + 2);
                        }
                    }}
                />}
                {formStep === 3 && <Button
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.confirm', { ns: 'app' })}//"Conferma"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={(event: Event) => {
                        //console.log(formData)
                        saveFormData();
                    }}
                />}
            </div>}
        </>
    )
}
export default ContractForm;